export default __webpack_public_path__ + "static/about-c2b801919f477bdb852d90311e55a4f3.jpg";